import {getQuery, postQuery, removeQuery} from "@/modules/common/utils";
import {putQuery} from "../../common/utils";

const MATTER_PATH = 'business/clients/v1/matters';
const AVATARS_PATH = 'business/clients/v1/avatars';

const get = uid => getQuery(`${MATTER_PATH}/${uid}`, {new_api: true});
const getMultiple = uidArr => getQuery(`${MATTER_PATH}`, {'filter[uid][in]': uidArr.toString(), new_api: true});
const getAvatars = uidArr => getQuery(`${AVATARS_PATH}`, {'filter[matter_uid][in]': uidArr.toString(), new_api: true});

const summary = uid => getQuery(`${MATTER_PATH}/${uid}/summary`, {new_api: true});

const removeCollaborators = (matterUid, staff_uid) => removeQuery(`${MATTER_PATH}/${matterUid}/collaborators/${staff_uid}`, {new_api: true});
const addCollaborators = (matterUid, staff_uid) => postQuery(`${MATTER_PATH}/${matterUid}/collaborators`, {new_api: true, collaborator:{staff_uid}});

const nestMatter = (matterUid, contact_uid) => putQuery(`${MATTER_PATH}/${matterUid}/nest`, {new_api: true, contact_uid});

export const matterService = {
  get,
  getMultiple,
  getAvatars,
  summary,
  removeCollaborators,
  addCollaborators,
  nestMatter
}
